import axios from 'axios'

const API_URL = process.env.REACT_APP_ENV === 'prod' ? process.env.REACT_APP_API_PROD_URL : process.env.REACT_APP_API_DEV_URL

export function getCompanyUsersData(props: any) {
  return axios.post(`${API_URL}/account/companyuser`, {...props})
}

export function createCompanyUser(props: any) {
  return axios.post(`${API_URL}/account/companyuser/create`, {...props})
}

export function createCompanyUserDevice(props: any) {
  return axios.post(`${API_URL}/account/companyuser/device/create`, {...props})
}

export function getTranslateData(props: any) {
  return axios.post(`${API_URL}/entitymetainfo/headerlabels`, {...props})
}

export function sendUserDeviceEmail(props: any) {
  return axios.post(`${API_URL}/account/companyuser/device/sendmail`, {...props})
}

export function sendUserDeviceToken(props: any) {
  return axios.post(`${API_URL}/account/companyuser/device/sendtoken`, {...props})
}

export function updateData(props: any) {
  return axios.post(`${API_URL}/account/companyUser/update`,  {...props})
}

export function updateDeviceData(props: any) {
  return axios.post(`${API_URL}/account/companyUser/device/update`,  {...props})
}

export function deleteData(props: any) {
  return axios.post(`${API_URL}/accont/companyUser/delete`,  {...props})
}

export function downLoadLicenceFile(props: any) {
  return axios.post(`${API_URL}/account/create/licencesxml`, {...props})
}

export function deleteDeviceData(props: any) {
  return axios.post(`${API_URL}/accont/companyUser/device/delete`,  {...props})
}

export function getDeviceInfo(props: any) {
  return axios.post(`${API_URL}/account/companyUser/device/info`, {...props})
}

export function getUserSettings(props: any) {
  return axios.post(`${API_URL}/account/user/settings`, {...props})
}

export function updateUserSettingsData(props: any) {
  return axios.post(`${API_URL}/account/user/settings/update`,  {...props})
}
export function syncServer(props: any) {
  return axios.post(`${API_URL}/syncdevice/mobisync`,  {...props})
}
export function updateSystemUsers(props: any) {
  return axios.post(`${API_URL}/account/systemuser/create`,  {...props})
}